<template>
  <div>
    <avue-crud ref="crud" :option="option" :data="fileData"
    @row-save="rowSave"
    @row-update="rowUpdate"
    v-model="rowValue"
    :before-open="beforeOpen">
      <template slot-scope="{type, size, row, index}" slot="menu">
        <el-button icon="el-icon-edit" :size="size" :type="type" @click.stop="rowEdit(row, index)" />
        <el-button icon="el-icon-delete" :size="size" :type="type" @click.stop="rowDel(row, index)" />
      </template>
      <template slot-scope="{row}" slot="modeForm">
        <editor v-model="row.mode" id="editorhtml1" />
      </template>
      <template slot-scope="{row}" slot="contentForm">
        <editor v-model="row.content" id="editorhtml2" />
      </template>
    </avue-crud>
  </div>
</template>

<script>
import editor from './templateFile/editor'
export default {
  props: ['data', 'widgetForm'],
  components: {
    editor
  },
  data() {
    const {
      fileData
    } = this.data
    return {
      fileData: fileData || [],

      // 编辑或新增临时存储值
      rowValue: {},

      option: {
        dialogFullscreen: true,
        page: false,
        refreshBtn: false,
        columnBtn: false,
        editBtn: false,
        delBtn: false,
        align: 'center',
        menuAlign: 'center',
        menuWidth: 70,
        column: [
          {
            label: '名称',
            prop: 'name',
            width: 80
          }, {
            label: '模版code',
            prop: 'code'
          }, {
            label: '设为默认',
            prop: 'isDefault',
            type: 'switch',
            value: false
          }, {
            label: '模版内容',
            hide: true,
            prop: 'mode',
            span: 24,
            formslot: true
          }, {
            label: '正文内容',
            hide: true,
            prop: 'content',
            span: 24,
            formslot: true
          }
        ]
      }
    }
  },
  watch: {
    fileData: {
      handler(val) {
        this.data.fileData = val
      },
      deep: true
    }
  },
  methods: {
    beforeOpen(done, type) {
      if (type === 'add') {
        console.log(this.rowValue)
        this.rowValue.mode = `
      <div>头部</div>
      <div style="height:5px; background:red; margin-bottom:1px;"></div><div style="height:2px; background:red; "></div>
      <p>正文区域（不可删除）</p>
      <div style="height:5px; background:red; margin-bottom:1px;"></div><div style="height:2px; background:red; "></div>
      <div>底部</div>`
      }
      done()
    },
    rowSave(form, done, loading) {
      done(form)
    },
    rowUpdate(form, index, done, loading) {
      const {
        isDefault,
        code
      } = form

      this.fileData.splice(index, 1, form)
      if (isDefault) {
        this.data.code = code
      }
      done()
    },
    rowEdit(row, index) {
      this.$refs.crud.rowEdit(row, index)
    },
    rowDel(form, index) {
      this.fileData.splice(index, 1)
    }
  }
}
</script>
